var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgToggleOn = function SvgToggleOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14 36q-5 0-8.5-3.5T2 24t3.5-8.5T14 12h20q5 0 8.5 3.5T46 24t-3.5 8.5T34 36Zm0-3h20q3.75 0 6.375-2.625T43 24t-2.625-6.375T34 15H14q-3.75 0-6.375 2.625T5 24t2.625 6.375T14 33m20.05-3.95q2.1 0 3.575-1.475T39.1 24t-1.475-3.575-3.575-1.475-3.575 1.475T29 24t1.475 3.575 3.575 1.475M24 24"
  })));
};
export default SvgToggleOn;